import { gql } from "@apollo/client";

const GET_INSTANCE_DOCUMENT_UPLOAD_URLS = gql`
  query GetInstanceDocumentUploadUrls($instanceId: Int!, $filenames: [String]!) {
    getInstanceDocumentUploadUrls(instanceId: $instanceId, filenames: $filenames) {
      success
      error
      urls {
        url
        key
        filename
      }
    }
  }
`;

const DELETE_INSTANCE_DOCUMENT = gql`
  mutation DeleteInstanceDocument($input: DeleteInstanceDocumentInput!) {
    deleteInstanceDocument(input: $input) {
      success
      error
      response
    }
  }
`;

export { GET_INSTANCE_DOCUMENT_UPLOAD_URLS, DELETE_INSTANCE_DOCUMENT };
